module.exports = __webpack_public_path__ + "static/media/feelingProud.1b365501.png";